export const FETCH_ROUGH_FABRIC_COSTING_HEADER_REQUEST = 'FETCH_ROUGH_FABRIC_COSTING_HEADER_REQUEST';
export const FETCH_ROUGH_FABRIC_COSTING_HEADER_SUCCESS = 'FETCH_ROUGH_FABRIC_COSTING_HEADER_SUCCESS';
export const FETCH_ROUGH_FABRIC_COSTING_HEADER_FAILURE = 'FETCH_ROUGH_FABRIC_COSTING_HEADER_FAILURE';

export const CREATE_ROUGH_FABRIC_COSTING_HEADER_REQUEST = 'CREATE_ROUGH_FABRIC_COSTING_HEADER_REQUEST';
export const CREATE_ROUGH_FABRIC_COSTING_HEADER_SUCCESS = 'CREATE_ROUGH_FABRIC_COSTING_HEADER_SUCCESS';
export const CREATE_ROUGH_FABRIC_COSTING_HEADER_FAILURE = 'CREATE_ROUGH_FABRIC_COSTING_HEADER_FAILURE';

export const CREATE_ROUGH_FABRIC_COSTING_DETAIL_REQUEST = 'CREATE_ROUGH_FABRIC_COSTING_DETAIL_REQUEST';
export const CREATE_ROUGH_FABRIC_COSTING_DETAIL_SUCCESS = 'CREATE_ROUGH_FABRIC_COSTING_DETAIL_SUCCESS';
export const CREATE_ROUGH_FABRIC_COSTING_DETAIL_FAILURE = 'CREATE_ROUGH_FABRIC_COSTING_DETAIL_FAILURE';

export const UPDATE_ROUGH_FABRIC_COSTING_HEADER_REQUEST = 'UPDATE_ROUGH_FABRIC_COSTING_HEADER_REQUEST';
export const UPDATE_ROUGH_FABRIC_COSTING_HEADER_SUCCESS = 'UPDATE_ROUGH_FABRIC_COSTING_HEADER_SUCCESS';
export const UPDATE_ROUGH_FABRIC_COSTING_HEADER_FAILURE = 'UPDATE_ROUGH_FABRIC_COSTING_HEADER_FAILURE';

export const FETCH_ROUGH_FABRIC_COSTING_DETAIL_REQUEST = 'FETCH_ROUGH_FABRIC_COSTING_DETAIL_REQUEST';
export const FETCH_ROUGH_FABRIC_COSTING_DETAIL_SUCCESS = 'FETCH_ROUGH_FABRIC_COSTING_DETAIL_SUCCESS';
export const FETCH_ROUGH_FABRIC_COSTING_DETAIL_FAILURE = 'FETCH_ROUGH_FABRIC_COSTING_DETAIL_FAILURE';

export const FETCH_ROUGH_FABRIC_COSTING_INVOICE_REQUEST = 'FETCH_ROUGH_FABRIC_COSTING_INVOICE_REQUEST';
export const FETCH_ROUGH_FABRIC_COSTING_INVOICE_SUCCESS = 'FETCH_ROUGH_FABRIC_COSTING_INVOICE_SUCCESS';
export const FETCH_ROUGH_FABRIC_COSTING_INVOICE_FAILURE = 'FETCH_ROUGH_FABRIC_COSTING_INVOICE_FAILURE';

export const DELETE_ROUGH_FABRIC_COSTING_HEADER_REQUEST = 'DELETE_ROUGH_FABRIC_COSTING_HEADER_REQUEST';
export const DELETE_ROUGH_FABRIC_COSTING_HEADER_SUCCESS = 'DELETE_ROUGH_FABRIC_COSTING_HEADER_SUCCESS';
export const DELETE_ROUGH_FABRIC_COSTING_HEADER_FAILURE = 'DELETE_ROUGH_FABRIC_COSTING_HEADER_FAILURE';

export const FETCH_SINGLE_ROUGH_FABRIC_COSTING_DATA_REQUEST = 'FETCH_SINGLE_ROUGH_FABRIC_COSTING_DATA_REQUEST';
export const FETCH_SINGLE_ROUGH_FABRIC_COSTING_DATA_SUCCESS = 'FETCH_SINGLE_ROUGH_FABRIC_COSTING_DATA_SUCCESS';
export const FETCH_SINGLE_ROUGH_FABRIC_COSTING_DATA_FAILURE = 'FETCH_SINGLE_ROUGH_FABRIC_COSTING_DATA_FAILURE';

export const CREATE_USERFORM_ROUGH_FABRIC_COSTING = 'CREATE_USERFORM_ROUGH_FABRIC_COSTING';

export const ROUGH_FABRIC_COSTING_USERFORM_RESET = 'ROUGH_FABRIC_COSTING_USERFORM_RESET';

export const ROUGH_FABRIC_COSTING_DETAIL_USERFORM_RESET = 'ROUGH_FABRIC_COSTING_DETAIL_USERFORM_RESET';

export const CREATE_USERFORM_ROUGH_FABRIC_COSTING_DETAIL = 'CREATE_USERFORM_ROUGH_FABRIC_COSTING_DETAIL';

export const NAVIGATE_ROUGH_FABRIC_COSTING = 'NAVIGATE_ROUGH_FABRIC_COSTING';

export const NAVIGATE_ROUGH_FABRIC_COSTING_DETAIL = 'NAVIGATE_ROUGH_FABRIC_COSTING_DETAIL';